import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ApplicationsIndex from "@/pages/ApplicationsIndex";
import ApplicationPage from "@/pages/ApplicationPage";
import MaterialsIndex from "@/pages/MaterialsIndex";
import MaterialPage from "@/pages/MaterialPage";
import ProductsIndex from "@/pages/ProductsIndex";
import ProductPage from "@/pages/ProductPage";
import EnquiryPage from "@/pages/EnquiryPage";
import AboutPage from "@/pages/AboutPage";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import NotFound from "@/pages/NotFound";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/applications" element={<ApplicationsIndex />} />
            <Route path="/applications/:slug" element={<ApplicationPage />} />
            <Route path="/materials" element={<MaterialsIndex />} />
            <Route path="/materials/:slug" element={<MaterialPage />} />
            <Route path="/products" element={<ProductsIndex />} />
            <Route path="/products/:slug" element={<ProductPage />} />
            <Route path="/capability" element={<AboutPage />} />
            <Route path="/journal" element={<BlogIndex />} />
            <Route path="/journal/:slug" element={<BlogPost />} />
            <Route path="/enquiry" element={<EnquiryPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster theme="light" position="bottom-center" />
      <div className="noise-overlay" aria-hidden="true" />
    </div>
  );
}

export default App;
